// Dev-only logger. Silent in production builds (process.env.NODE_ENV === 'production').
// Use this for diagnostic messages that should not pollute end-user consoles.
const isDev = typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
};

export default logger;
